const initialState = {
  loading: false,
  loadError: false,
  templates: [],
  denyList: null
}

export default initialState
